import React from 'react';
import './QuestionScreen.css';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';
import Heading from '../Heading/Heading';
const question_gnt = new URL('./graphics/question--gnt.jpg', import.meta.url);
const question_ant = new URL('./graphics/question--ant.jpg', import.meta.url);

const QuestionScreen = ({ language, location }) => {

     // get translations
    const {t} = useTranslation();

    // render html
    return(
        <div className={`questionScreen`}>
            <div className={`questionScreen__box`}>
                <Heading size="m">{ t('question_heading') }</Heading>
                <div className={`questionScreen__visual`}>
                    {(location === "gnt") ? (
                        <img src={question_gnt} alt="Location" />
                    ) : (
                        <img src={question_ant} alt="Location" />
                    )}
                </div>
                <div className={`questionScreen__actions`}>
                    <Button path={`/${location}/${language}`}>{ t('question_cta') } <span>»</span></Button>
                </div>
            </div>
        </div>
    );
}

export default QuestionScreen;